import { axios } from "../config/axios";
import { globalGetUser } from ".";

type Obj = Record<string, unknown> | {};

type RequestParams = Partial<{
  headers: Record<string, string>;
  body: Obj;
}>;

type RequestMethods = "GET" | "PUT" | "POST" | "PATCH" | "DELETE";

async function request<T = Obj>(
  requestUrl: string,
  method: RequestMethods,
  params?: RequestParams
): Promise<T | null> {
  const user = globalGetUser();
  const token = user?.access_token;

  const response = await axios.api().request<T>({
    headers: {
      Authorization: `Bearer ${token}`,
      ...(params?.headers || {}),
    },
    method: method,
    url: requestUrl,
    data: params?.body,
  });

  return response.data;
}

export async function get<T = Obj>(
  requestUrl: string,
  params?: RequestParams
): Promise<T | null> {
  return request<T>(requestUrl, "GET", params);
}

export async function put<T = Obj>(
  requestUrl: string,
  params?: RequestParams
): Promise<T | null> {
  return request<T>(requestUrl, "PUT", params);
}

export async function post<T = Obj>(
  requestUrl: string,
  params?: RequestParams
): Promise<T | null> {
  return request<T>(requestUrl, "POST", params);
}

export async function patch<T = Obj>(
  requestUrl: string,
  params?: RequestParams
): Promise<T | null> {
  return request<T>(requestUrl, "PATCH", params);
}

export async function toDelete<T = Obj>(
  requestUrl: string,
  params?: RequestParams
): Promise<T | null> {
  return request<T>(requestUrl, "DELETE", params);
}
